export const navItems = [
  { id: 'historia', label: 'Historia' },
  { id: 'nosotros', label: 'Nosotros' },
  { id: 'principios', label: 'Principios' },
  { id: 'calidad', label: 'Calidad' },
  { id: 'proyeccion', label: 'Proyección' },
];
